import HttpV2 from './HttpV2';

class PackageServiceV2 {
  static async exportPackages() {
    return HttpV2.get(`admin/packages/export`, {
      responseType: 'blob',
    });
  }
}

export default PackageServiceV2;
